/**
 * Os nomes dos plugins web na língua da interface: o manifesto pode trazer o nome, a descrição e os
 * títulos como `{ "pt": "Ficha", "en": "Sheet" }`, e o servidor manda as traduções em `web.names`,
 * `web.descriptions` e `web.titles` (o `name`, a `description` e o `title` de sempre são os em
 * português).
 */
import type { Language } from '../i18n/index.js';
import type { RoomPlugin } from '../shared.js';
import { localize } from './web/sdk.js';

export function localizePlugins(plugins: readonly RoomPlugin[], language: Language): RoomPlugin[] {
  return plugins.map((plugin) => {
    const names = plugin.web?.names;
    const descriptions = plugin.web?.descriptions;
    const titles = plugin.web?.titles;
    if (!names && !descriptions && !titles) return plugin;
    return {
      ...plugin,
      name: (names && localize(names, language)) || plugin.name,
      ...(descriptions && plugin.web ? { web: { ...plugin.web, description: localize(descriptions, language) || plugin.web.description } } : {}),
      dataTypes: plugin.dataTypes.map((d) => {
        const title = titles?.[d.id];
        return title ? { ...d, title: localize(title, language) || d.title } : d;
      }),
    };
  });
}
